<template>
  <v-row justify="center">
    <v-dialog
      v-model="openModal"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6">
          Input kode TTB / No TTB
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.kodettb"
            label="Kode TTB"
            outlined
            hide-details
            @keydown.enter="checkTTB"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FindKodeTTBModal',
  props: ['openModal'],
  data() {
    return {
      formData: {
        kodettb: ''
      },
      loading: false
    }
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.kodettb = '';
      }
    },
    "formData.kodettb"(val) {
      if (val) {
        this.formData.kodettb = val.toUpperCase();
      }
    }
  },
  methods: {
    async checkTTB() {
      this.loading = true;

      await axios.post(`check-kodettb`, this.formData)
        .then(res => {
          this.loading = false;

          if (Object.keys(res.data).length === 0) {
            this.fetchNewData();
          } else {
            this.fetchTTBData(res.data.kodettb);
          }
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchNewData() {
      this.laoding = true;

      await axios.get(`kodettb`)
        .then(res => {
          this.loading = false;

          this.$emit('close-modal', res.data);
        })
        .catch(err => {
          this.loading = false;
          
          alert(err.response.data.message);
        });
    },
    async fetchTTBData(id) {
      this.loading = true;

      await axios
        .get(`ttb/${id}`)
          .then(res => {
            this.loading = false;

            this.$emit('close-modal', res.data);
          })
          .catch(err => {
            this.loading = false;

            alert(err.response.data.message);
          });
    },
  },
}
</script>